import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const AppHeaderStyled = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  height: 48px;
  justify-content: space-between;
  border-bottom: 1px solid ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
  background: ${ct({ Dark: Colors.White, Light: Colors.White })};
`;
